import { apiAuth, apiResponseType } from ".";

export const getUnitiesData = (
  page: number = 1,
  unity_id?: string
): apiResponseType =>
  apiAuth.get(`unities?page=${page}${unity_id ? `&id=${unity_id}` : ""}`);

export const registerUnitiesData = (data) =>
  apiAuth.postForm("/unities/store", data) as apiResponseType;
export const deleteUnitiesData = (tenid: string) =>
  apiAuth.delete(`unities/${tenid}/destroy`) as apiResponseType;
export const updateUnitiesData = (tenid: string, data) =>
  apiAuth.postForm(`unities/${tenid}/update`, data) as apiResponseType;

export const getShowUnities = (tenid: string) =>
  apiAuth.get(`unities/${tenid}/show`) as apiResponseType;

export const searchUnitiesData = (params: {
  name: string;
  id?: string;
}): apiResponseType =>
  apiAuth.get(
    `unities?name=${params.name}${params.id ? `&id=${params.id}` : ""}`
  );

export const setStatusUnities = (tenid: string) =>
  apiAuth.put(`unities/${tenid}/toggle-status`) as apiResponseType;

export const getSelectUnities = () =>
  apiAuth.get(`unities/select`) as apiResponseType;

export const getSelectUnitiesOnlyActives = () =>
  apiAuth.get(`unities/select-only-actives`) as apiResponseType;

export const getSelectUnitiesForDashboard = () =>
  apiAuth.get(`unities/select-for-dashboard`) as apiResponseType;

export const getSelectUnitiesWithStockists = () =>
  apiAuth.get(`unities/select-has-stockist`) as apiResponseType;

export const registerUserUnities = (uuidUnit: string, data) =>
  apiAuth.postForm(`unities/${uuidUnit}/users/store`, data) as apiResponseType;

export const getUsersTenantData = (uuidUnit: string, page: number = 1) =>
  apiAuth.get(`unities/${uuidUnit}/users?page=${page}`) as apiResponseType;

export const getShowUserTenant = (uuidUnit: string, uuidUser: string) =>
  apiAuth.get(`unities/${uuidUnit}/users/${uuidUser}/show`) as apiResponseType;

export const searchUserTenantData = (
  uuidUnit: string,
  params: { name: string }
) =>
  apiAuth.get(
    `unities/${uuidUnit}/users?name=${params.name}`
  ) as apiResponseType;

export const deleteUserUnities = (uuidUnit: string, uuidUser: string) =>
  apiAuth.delete(
    `unities/${uuidUnit}/users/${uuidUser}/destroy`
  ) as apiResponseType;

export const updateUserUnities = (uuidUnit: string, uuidUser: string, data) =>
  apiAuth.postForm(
    `unities/${uuidUnit}/users/${uuidUser}/update`,
    data
  ) as apiResponseType;

export const setStatusUserUnities = (uuidUnit: string, uuidUser: string) =>
  apiAuth.put(
    `unities/${uuidUnit}/users/${uuidUser}/toggle-status`
  ) as apiResponseType;
